import { FuseAuth, FuseLayout, FuseTheme } from '@fuse';
import 'babel-polyfill';
import { create } from 'jss';
import jssExtend from 'jss-extend';
import QuickPanel from 'main/quickPanel/QuickPanel';
import { createGenerateClassName, jssPreset } from 'material-ui/styles';
import React from 'react';
import { Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import ReactDOM from 'react-dom';
import JssProvider from 'react-jss/lib/JssProvider';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import store from 'store';
import 'typeface-roboto';
import { routes } from './fuse-configs/fuseRoutesConfig';
import history from './history';
import MainFooter from './main/MainFooter';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainToolbar from './main/MainToolbar';
import './react-table-defaults';
import './styles/index.css';

const jss = create({
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});

const options = {
    position: 'bottom center',
    timeout: 5000,
    offset: '30px',
    transition: 'scale',
    zIndex: 100
}
//h2bis
// window.panel = 'LEFT'


/**
 * enviroment
 * ICSC, IMC
 */
var env = "IMC";
window.env = env;
window.CASH_BOOK_LEDGER_ID = 6;

window.DATABASE_TYPE = env === "IMC" ? "MYSQL" : "MYSQL_PLUS_MONGO";

// window.authServer = 'http://192.169.143.105:5000';
// window.systemServer = 'http://192.169.143.105:5001';
// window.hrmServer = 'http://192.169.143.105:5002';
// window.crmServer = 'http://192.169.143.105:5003';
// window.inventoryServer = 'http://192.169.143.105:5004';
// window.accountServer = 'http://192.169.143.105:5009';
// window.salesServer = 'http://192.169.143.105:5006';
// window.salesServer = 'http://192.169.143.105:5006';
// window.productionServer = 'http://192.169.143.105:5007';
// window.reportServer = 'http://192.169.143.105:5008';
// window.imageUploadServer = 'http://192.169.143.105:3006';
if (env === "IMC") {
    /**
   * IMC Live
   */
    //IMC 203.94.75.114:
    // window.authServer = 'http://203.94.75.114:7103';
    // window.systemServer = 'http://203.94.75.114:7107';
    // window.hrmServer = 'http://203.94.75.114:7101';
    // window.crmServer = 'http://203.94.75.114:7104';
    // window.inventoryServer = 'http://203.94.75.114:7102';
    // window.reportServer = 'http://203.94.75.114:7105';
    // window.accountServer = 'http://203.94.75.114:7100';
    // window.salesServer = 'http://203.94.75.114:7106';
    // window.productionServer = 'http://203.94.75.114:2007';
    // window.imageUploadServer = 'http://203.94.75.114:7108';
    window.authServer = 'https://imc.h2bis.com:7103';
    window.systemServer = 'https://imc.h2bis.com:7107';
    window.hrmServer = 'https://imc.h2bis.com:7101';
    window.crmServer = 'https://imc.h2bis.com:7104';
    window.inventoryServer = 'https://imc.h2bis.com:7102';
    window.reportServer = 'https://imc.h2bis.com:7105';
    window.accountServer = 'https://imc.h2bis.com:7100';
    window.salesServer = 'https://imc.h2bis.com:7106';
    window.productionServer = 'https://imc.h2bis.com:2007';
    window.imageUploadServer = 'https://imc.h2bis.com:7108';

    /**
     * DEMO IMC
     */
    // window.authServer = 'https://demoicm.h2bis.com:6713';
    // //window.systemServer = 'http://localhost:2001';
    // window.systemServer = 'https://demoicm.h2bis.com:6717';
    // window.hrmServer = 'https://demoicm.h2bis.com:6711';
    // window.crmServer = 'https://demoicm.h2bis.com:6714';
    // window.inventoryServer = 'https://demoicm.h2bis.com:6712';
    // window.reportServer = 'https://demoicm.h2bis.com:6715';
    // window.accountServer = 'https://demoicm.h2bis.com:6710';
    // window.salesServer = 'https://demoicm.h2bis.com:6716';
    // window.productionServer = 'https://demoicm.h2bis.com:2007';
    // window.imageUploadServer = 'https://demoicm.h2bis.com:6718';
} else {
    //icsc203.94.75.115:
    window.authServer = 'http://203.94.75.115:6133';
    window.systemServer = 'http://203.94.75.115:6137';
    window.hrmServer = 'http://203.94.75.115:6131';
    window.crmServer = 'http://203.94.75.115:6134';
    window.inventoryServer = 'http://203.94.75.115:6132';
    window.accountServer = 'http://203.94.75.115:6130';
    window.salesServer = 'http://203.94.75.115:6136';
    window.productionServer = 'http://203.94.75.115:2007';
    window.reportServer = 'http://203.94.75.115:6135';
    window.imageUploadServer = 'http://203.94.75.115:3006';
}
// window.accountServer = 'http://localhost:5009';
// window.crmServer = 'http://localhost:2003';

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();


ReactDOM.render(
    <AlertProvider template={AlertTemplate} {...options}>
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <Provider store={store}>
                <Router history={history}>
                    <FuseAuth routes={routes}>
                        <FuseTheme>
                            <FuseLayout
                                routes={routes}
                                toolbar={
                                    <MainToolbar />
                                }
                                navbarHeader={
                                    <MainNavbarHeader />
                                }
                                navbarContent={
                                    <MainNavbarContent />
                                }
                                footer={
                                    <MainFooter />
                                }
                            />
                            {/* <FuseSettings/> */}
                            <QuickPanel />
                        </FuseTheme>
                    </FuseAuth>
                </Router>
            </Provider>
        </JssProvider>
    </AlertProvider>
    , document.getElementById('root'));

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js